module.exports = __webpack_public_path__ + "img/34.9616343c.jpg";